module.exports = __webpack_public_path__ + "static/media/image-placeholder.1d9a793c.png";